import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, Phone, MapPin, Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-charcoal-grey text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img src="/logo.svg" alt="Animal Care India" className="h-10 md:h-14 w-auto max-w-[180px] md:max-w-[220px]" />
              {/* <h3 className="text-lg font-bold font-heading">Animal Care India</h3> */}
            </div>
            <p className="text-gray-300 text-sm mb-4">
              Dedicated to the rescue, treatment, rehabilitation, and adoption of street animals across India.
            </p>
            <div className="flex space-x-3">
              <a href="https://www.facebook.com/animalcareindia.org.in/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 hover:scale-110 transition-transform duration-200">
                <img src="https://cdn.simpleicons.org/facebook" alt="Facebook" className="w-full h-full" />
              </a>
              <a href="https://www.instagram.com/animalcareindia.org.in/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 hover:scale-110 transition-transform duration-200">
                <img src="https://cdn.simpleicons.org/instagram" alt="Instagram" className="w-full h-full" />
              </a>
              <a href="https://twitter.com/search?q=%23AnimalCareIndia&src=hashtag_click&f=user" target="_blank" rel="noopener noreferrer" className="w-10 h-10 hover:scale-110 transition-transform duration-200">
                <img src="https://cdn.simpleicons.org/x" alt="X (Twitter)" className="w-full h-full" />
              </a>
              <a href="https://www.linkedin.com/company/animalcareindia/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" className="w-10 h-10 hover:scale-110 transition-transform duration-200">
                <img src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png" alt="LinkedIn" className="w-full h-full" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 font-heading">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-gray-300 hover:text-warm-amber transition-colors duration-200">About Us</Link></li>
              <li><Link to="/our-work" className="text-gray-300 hover:text-warm-amber transition-colors duration-200">Our Work</Link></li>
              <li><Link to="/adopt" className="text-gray-300 hover:text-warm-amber transition-colors duration-200">Adopt a Furry Friend</Link></li>
              <li><Link to="/volunteer" className="text-gray-300 hover:text-warm-amber transition-colors duration-200">Become a Volunteer</Link></li>
              <li><Link to="/pawsitive-protectors" className="text-gray-300 hover:text-warm-amber transition-colors duration-200">Pawsitive Protectors</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-warm-amber transition-colors duration-200">Stories & Blog</Link></li>
            </ul>
          </div>

          {/* Other Ways to Help */}
          <div>
            <h4 className="text-lg font-semibold mb-4 font-heading">Other Ways to Help</h4>
            <ul className="space-y-2 text-sm">

              <li><a href="#" className="text-gray-300 hover:text-warm-amber transition-colors duration-200">Sponsor a Bowl</a></li>
              <li><a href="#" className="text-gray-300 hover:text-warm-amber transition-colors duration-200">Spread Awareness</a></li>
              <li><a href="#" className="text-gray-300 hover:text-warm-amber transition-colors duration-200">Foster an Animal</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 font-heading">Contact Us</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-warm-amber" />
                <span>House No 16, Upper Ground Floor, Near State Bank Of India, Sultanpur, New Delhi, 110030</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-warm-amber" />
                <a href="tel:+919315982650" className="hover:text-warm-amber">+91 9315982650</a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 flex-shrink-0 text-warm-amber" />
                <a href="mailto:info@animalcareindia.org.in" className="hover:text-warm-amber">info@animalcareindia.org.in</a>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-xs text-gray-400">Working Hours:</p>
              <p className="text-sm text-gray-300">Mon-Sun: 24/7 Emergency</p>
              <p className="text-sm text-gray-300">Office: 9 AM - 6 PM</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © 2025 Animal Care India. All rights reserved.
            </p>
            <div className="flex space-x-4 text-sm text-gray-400">
              <Link to="/privacy" className="hover:text-warm-amber transition-colors duration-200">Privacy Policy</Link>
              <span>|</span>
              <Link to="/terms" className="hover:text-warm-amber transition-colors duration-200">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;